<template>
  <div style="overflow: hidden;" id="app">
    <div style="display: flex; flex-direction: row; height: 100%; ">
      <div
        v-if="device === 'mobile' && !isCollapse"
        style="position: relative; min-width: 210px;"
        class="sidebar-container mobile"
      >
        <!-- <el-row class="rowTop">
          <span
            style="width: 100%; text-align: left; color: #000; font-size: 18px; font-weight: normal;"
            >Hi, {{ username }}</span
          >
        </el-row>
        <el-row class="rowTop4">
          <div
            v-if="companies.length > 1"
            style="display: flex; width: 100%; justify-content: center; align-items: flex-start; flex-direction: column; margin-top: 10px; margin-bottom: 10px;"
          >
            <el-button @click="() => switchCompany()" type="dark" size="medium" round
              >Switch Company</el-button
            >
          </div>
          <div
            style="display: flex; flex-direction: column; width: 100%;"
            v-if="branchData"
          >
            <span
              v-if="branchData.regionId"
              style="width: 100%; text-align: left; color: var(--darkest-border-color); font-size: 14px; margin-bottom: 4px; margin-top: 4px;"
              >{{ branchData.regionId.companyId && branchData.regionId.companyId.name ? branchData.regionId.companyId.name : "-" }}</span
            >
            <el-tag
              v-if="branchData.relation"
              type="lightfill"
              style="height: 100%; width: fit-content; text-align: left; font-size: 14px; margin-top: 0px; padding: 4px; line-height: 14px;"
              >{{ branchData.relation.role | roleFilter }}</el-tag
            >
          </div>
        </el-row> -->
        <el-row class="rowTop" style="margin-bottom: 20px;">
          <div
            style="display: flex; flex-direction: column; width: 100%; justify-content: center; align-items: flex-start;"
          >
            <template v-if="branchData">
              <span 
                v-if="branchData.relation"
                class="primaryTextColor" style="text-align: left; font-size: 18px; font-weight: 700;"
                >
                {{ branchData.relation.role | roleFilter }}
              </span>
              <!-- <span
                v-if="mypetrolProfileData"
                class="primaryTextColor" style="text-align: left; font-size: 14px; color: var(--darker-border-color)"
                >
                {{ mypetrolProfileData.userGeneralName }}
              </span> -->
            </template>
          </div>
        </el-row>
        <el-scrollbar wrapClass="scrollbar-wrapper">
          <el-menu
            mode="vertical"
            :show-timeout="200"
            :default-active="$route.path"
            :collapse="isCollapse"
            style="height: auto;"
          >
            <sidebar-item :routes="permission_routers"></sidebar-item>
          </el-menu>
          <el-menu
            mode="vertical"
            :show-timeout="200"
            :default-active="$route.path"
            :collapse="isCollapse"
            style="height: auto; margin-top: 20px;"
          >
            <div class="menu-wrapper">
              <template>
                <!-- <div v-if="branchSelected" @click="projectLeave()">
                  <el-menu-item
                    index="/projects"
                    :class="{ 'submenu-title-noDropdown': true }"
                  >
                    <i class="el-icon-back"></i>
                    <span slot="title">
                      Projects
                    </span>
                  </el-menu-item>
                </div> -->
                <!-- <el-menu-item>
                  <a href="/">
                    <el-button type="primary">
                      <i style="color: var(--darkest-border-color)" class="el-icon-arrow-left"></i>Muka Depan
                    </el-button>
                  </a>
                </el-menu-item> -->
                <el-menu-item
                  index="/logout"
                  @click="logout"
                  class="submenu-title-noDropdown"
                >
                  <el-button type="secondary">
                    <i style="color: var(--darkest-border-color)" class="el-icon-switch-button"></i>Log Keluar
                  </el-button>
                </el-menu-item>
              </template>
            </div>
          </el-menu>
        </el-scrollbar>
      </div>
      <div
        :style="
          device === 'mobile' && globalSidebar === true
            ? 'left: 240px; position: absolute;'
            : ''
        "
        style="display: flex; flex-direction: column; height: 100%; width: 100%;"
      >
        <header v-if="burgerAllowed" style="height: 56px;">
          <div class="headerClass">
            <div
              style="flex: 1; display: flex; align-items: center; justify-content: flex-start; flex-direction: row;"
            >
              <!-- <span>{{ branchLogo.toString() }}</span> -->
              <a href="/" style="display: flex; flex-direction: row; justify-content: center; align-items: center;">
                <img class="appLogo" :src="jatalogo" />
                <img class="appLogo madaniMargin" :src="madani" />
              </a>
            </div>
            <div style="flex: 2; display: flex; align-items: center; justify-content: center; flex-direction: row;">
              <!-- padding-left: 127.5px; padding-right: 193.18px; -->
              <span style="color: #000; font-size: 20px; font-weight: 700;">
                {{currentFeature === 'mypetrol' ? 'MyPetrol' : currentFeature === 'mydiesel' ? 'MyDiesel' : 'MySubsidi' }}
              </span>
              <span v-if="currentFeature === 'mypetrol'">
                <div class="iconBackground" style="margin-left: 10px; width: 40px; height: 40px; background-color: var(--yellow3);">
                  <svg-icon style="width: 1.5em; height: 1.5em;"
                  icon-class="yellow-nozzle"/>
                </div>
              </span>
              <span v-if="currentFeature === 'mydiesel'">
                <div class="iconBackground" style="margin-left: 10px; width: 40px; height: 40px; background-color: #f4f4f4;">
                  <svg-icon style="width: 1.5em; height: 1.5em;"
                  icon-class="black-nozzle"/>
                </div>
              </span>
              <span v-if="currentFeature === 'mysubsidi'">
                <div style="display: flex; flex-direction: row;">
                  <div class="iconBackground" style="margin-left: 10px; width: 40px; height: 40px; background-color: var(--yellow3);">
                    <svg-icon style="width: 1.5em; height: 1.5em;"
                    icon-class="yellow-nozzle"/>
                  </div>
                  <div class="iconBackground" style="margin-left: 10px; width: 40px; height: 40px; background-color: #f4f4f4;">
                    <svg-icon style="width: 1.5em; height: 1.5em;"
                    icon-class="black-nozzle"/>
                  </div>
                </div>
              </span>
            </div>
            <!-- <nav
              v-if="device !== 'mobile'"
              style="flex: 2; display: flex; justify-content: center; align-items: center;"
            >
              <div style="width: 100%;">
                <ul
                  style="display: flex; list-style: none; margin: 0; padding: 0; flex-direction: row; flex-wrap: wrap;"
                >
                </ul>
              </div>
            </nav> -->
            <div
              v-if="token === '' && device !== 'mobile'"
              style="flex: 1; display: flex; flex-direction: row; align-items: center; justify-content: center;"
            ></div>
            <div
              v-else-if="device !== 'mobile'"
              style="flex: 1; display: flex; flex-direction: row; align-items: center; justify-content: flex-end;"
            >
              <el-dropdown style="margin-left: 10px;" trigger="click">
                <span
                  style="display: flex; flex-direction: row; justify-content: center; align-items: center; cursor: pointer; color: var(--primary2-color);"
                >
                  <!-- <i class="el-icon-user-solid"></i> -->
                  <!-- <img
                    v-if="profilePicture"
                    style="display: flex; width: 35px; height: 35px; margin-right: 12px;"
                    :src="profilePicture"
                  />
                  <div
                    v-else
                    style="display: flex; width: 35px; height: 35px; margin-right: 12px; background-color: #000;"
                  ></div> -->
                  <span v-if="mypetrolProfileData.userGeneralName" style="display: flex; width: 100%; height: 100%;"
                    >
                    {{ mypetrolProfileData.userGeneralName }}
                    <i style="margin-left: 5px;" class="el-icon-arrow-down"></i
                  ></span>
                  <span v-else style="display: flex; width: 100%; height: 100%;"
                    >
                    {{ awakRole !== "none" ? username : username }}
                    <i style="margin-left: 5px;" class="el-icon-arrow-down"></i
                  ></span>
                </span>
                <el-dropdown-menu class="user-dropdown" slot="dropdown">
                  <el-dropdown-item>
                    <span @click="logout" style="display:block;">Log Keluar</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <span
                class="colorModeDiv"
              >
                <svg-icon icon-class="sun" :class="!tempColorMode ? 'active' : ''" />
                <el-switch
                  :value="tempColorMode"
                  @change="toggleColorMode"
                  style="margin-left: 5px; margin-right: 5px;"
                  active-color="#00FF41"
                  inactive-color="#DCDFE6">
                </el-switch>
                <svg-icon icon-class="moon" :class="tempColorMode ? 'active' : ''" />
              </span> -->
            </div>
            <hamburger
              v-if="device === 'mobile'"
              style="position: relative; display: flex; flex-direction: row; flex: 1 1 0%; justify-content: flex-end;"
              class="hamburger-container"
              :toggleClick="toggleGlobalSideBar"
              :isActive="globalSidebar.opened"
            ></hamburger>
          </div>
        </header>
        <div ref="routerParent" @click="handleClickOutside()" style="display: flex; width: 100%; height: 100%;">
          <router-view :switchCompany="switchCompany" :nextBranch="nextBranch"></router-view>
        </div>
      </div>
    </div>
    <footer>
      <!-- <cookie-law theme="kpdn"></cookie-law> -->
    </footer>
    <el-dialog
      v-loading="signInLoading"
      :visible.sync="signInPopup.opened"
      :before-close="signInClose"
      title=""
      width="300px"
    >
      <p
        style="color: #000; font-size: 21px; margin: 0px 0px; text-align: center;"
      >
        Sign in to
      </p>
      <p
        class="titleColor"
        style="font-size: 36px; margin: 40px 0px; font-family: CaviarDreams; font-weight: bold; text-align: center; margin-top: 30px; margin-bottom: 20px;"
      >
        {{ title }}
      </p>
      <div
        @click="google"
        style="display: flex; flex-direction: row; width: 100%; height: 50px; border-radius: 4px; margin-top: 20px; padding: 2px; cursor: pointer;"
        :style="
          agePermission
            ? 'background-color: #4285f4; cursor: pointer;'
            : 'background-color: #ccc; cursor: default;'
        "
      >
        <div
          style="display: flex; justify-content: center; align-items: center; width: 60px; background-color: #fff;"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 533.5 544.3"
            style="width: 18px;"
          >
            <path
              d="M533.5 278.4c0-18.5-1.5-37.1-4.7-55.3H272.1v104.8h147c-6.1 33.8-25.7 63.7-54.4 82.7v68h87.7c51.5-47.4 81.1-117.4 81.1-200.2z"
              fill="#4285f4"
            ></path>
            <path
              d="M272.1 544.3c73.4 0 135.3-24.1 180.4-65.7l-87.7-68c-24.4 16.6-55.9 26-92.6 26-71 0-131.2-47.9-152.8-112.3H28.9v70.1c46.2 91.9 140.3 149.9 243.2 149.9z"
              fill="#34a853"
            ></path>
            <path
              d="M119.3 324.3c-11.4-33.8-11.4-70.4 0-104.2V150H28.9c-38.6 76.9-38.6 167.5 0 244.4l90.4-70.1z"
              fill="#fbbc04"
            ></path>
            <path
              d="M272.1 107.7c38.8-.6 76.3 14 104.4 40.8l77.7-77.7C405 24.6 339.7-.8 272.1 0 169.2 0 75.1 58 28.9 150l90.4 70.1c21.5-64.5 81.8-112.4 152.8-112.4z"
              fill="#ea4335"
            ></path>
          </svg>
        </div>
        <div
          style="flex: 1; display: flex; justify-content: center; align-items: center;"
        >
          <span style="color: #fff; font-weight: 500;">Google</span>
        </div>
      </div>
      <div
        style="display: flex; flex-direction: column; align-items: center; justify-content: center; margin-top: 10px;"
      >
        <span
          @click="
            agePermission ? (agePermission = false) : (agePermission = true)
          "
          style="width: 100%; text-align: center; cursor: pointer;"
          ><el-checkbox style="margin-right: 10px;" v-model="agePermission" />I
          confirm that I am at least <b>18</b> years old, or at least 13 years
          old <b>with</b> parental permission to use this website.</span
        >
        <!-- <span><el-checkbox v-model="agePermission"/>I agree</span> -->
      </div>
    </el-dialog>
    <el-dialog
      title="Switch Company Branch"
      :visible.sync="userBranch"
      :before-close="resetForm"
    >
      <!-- <el-form ref="currUser2" :model="currUser2"> -->
      <div style="display: flex; flex-direction: row; width: 100%; padding-left: 2px; padding-right: 2px;">
        <el-input class="border2px" placeholder="Carian" style="width: 100%; margin-left: 0px;" @change="()=>searchBranch()" v-model="branchSearch">
          <i slot="suffix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <!-- <el-button
          style="margin-left: 10px;"
          type="primary"
          size="mini"
          icon="el-icon-search"
        ></el-button> -->
      </div>
      <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center; flex-wrap: wrap; overflow: hidden; padding-left: 0px; padding-right: 0px; padding-top: 10px;" v-if="!branchLoading">
        <el-button class="tagButton" :type="`${currUser2.company === item._id ? 'dark' : 'secondary'}`" v-for="(item, key) in filteredCompanies" :key="key" @click="()=>{
            if (currUser2.company !== item._id) {
              currUser2.company = item._id;
              currUser2.region = 0;
              currUser2.branch = 0;
              selectBranch()
            }
          }">
          {{ item.relationId ? item.relationId.name : '-' }}
        </el-button>
        <!-- <div
          class="companyList"
          v-for="(item, key) in filteredCompanies"
          :key="key">
          <div
          class="companyButton"
          :class="currUser2.company === item._id ? 'active' : 'inactive'"
          @click="() => {
            if (currUser2.company !== item._id) {
              currUser2.company = item._id;
              currUser2.region = 0;
              currUser2.branch = 0;
              selectBranch()
            }
          }">
            <p>{{item.relationId ? item.relationId.name : '-'}}</p>
          </div>
        </div> -->
      </div>
      <!-- <span>seperator</span>
      <div style="display: flex; flex-direction: row; flex-wrap: wrap;" v-if="!branchLoading">
        <div
          class="companyList"
          v-for="(item, key) in companies"
          :key="key">
          <div
          class="companyButton"
          :class="currUser2.company === key ? 'active' : 'inactive'"
          @click="() => {
            if (currUser2.company !== key) {
              currUser2.company = key;
              currUser2.region = 0;
              currUser2.branch = 0;
              selectBranch()
            }
          }">
            <p>{{item.relationId ? item.relationId.name : '-'}}</p>
          </div>
        </div>
      </div> -->
      <!-- <el-form-item label="Company">
        <el-select
          @change="
            () => {
              currUser2.region = 0;
              currUser2.branch = 0;
              selectBranch()
            }
          "
          class="el-input-size"
          v-model="currUser2.company"
        >
          <el-option
            :value="null"
            label="- Select -"
          >
            - Select -
          </el-option>
          <el-option
            v-for="(item, key) in companies"
            :key="key"
            :value="key"
            :label="item.name"
          >
            {{ item.relationId ? item.relationId.name : '-' }}
          </el-option>
        </el-select>
      </el-form-item> -->
      <!-- <el-form-item label="Region">
        <el-select
          :disabled="true"
          @change="
            () => {
              currUser2.branch = 0;
            }
          "
          class="el-input-size"
          v-model="currUser2.region"
        >
          <div v-if="companies.length > 0 && currUser2.company !== null">
            <el-option
              v-for="(item, key) in companies[currUser2.company].regions"
              :key="key"
              :value="key"
              :label="item.name"
            >
              {{ item.name }}
            </el-option>
          </div>
        </el-select>
      </el-form-item>
      <el-form-item label="Branch">
        <el-select
          :disabled="true"
          class="el-input-size"
          v-model="currUser2.branch"
        >
          <div v-if="companies.length > 0 && companies[currUser2.company].regions.length > 0 && currUser2.region !== null">
            <el-option
              v-for="(item, key) in companies[currUser2.company].regions[currUser2.region].branches"
              :key="key"
              :value="key"
              :label="item.name"
            >
              {{ item.name }}
            </el-option>
          </div>
        </el-select>
      </el-form-item> -->
      <!-- </el-form> -->
      <span slot="footer" class="dialog-footer">
        <el-button type="secondary" @click="resetForm">Batal</el-button>
        <!-- <el-button v-loading="btnloading" type="primary" @click="selectBranch"
          >Sahkan</el-button
        > -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CookieLaw from "vue-cookie-law";
import Hamburger from "@/components/Hamburger";
import { mapGetters } from "vuex";
import SidebarItem from "./views/admin/layout/components/Sidebar/SidebarItem";
import defaultLogo from "./assets/jata.jpeg";
import kpdnlogo from '@/assets/mypetrol-kpdn.png'
import jatalogo from '@/assets/jata.jpeg'
import madani from '@/assets/madani.png'
// import sun from './icons/svg/sun.svg'
// import moon from './icons/svg/moon.svg'
import "@/permission";
import ResizeMixin from "@/mixin/ResizeHandler";
import moment from "moment";
import Cookies from 'js-cookie'
// import SocketIO from 'socket.io-client'

export default {
  name: "App",
  components: { CookieLaw, Hamburger, SidebarItem },
  mixins: [ResizeMixin],
  data() {
    return {
      title: process.env.APP_NAME.toUpperCase(),
      appname: process.env.APP_NAME,
      currUser2: {
        company: null,
        region: 0,
        branch: 0
      },
      logo: null,
      year: "",
      filteredCompanies: [],
      branchSearch: "",
      branchLoading: false,
      // notificationSocket: null,
      signInLoading: false,
      agePermission: false,
      userBranch: false,
      // colorMode: false,
      refreshPageAfter: false,
      defaultLogo,
      tempColorMode: false,
      kpdnlogo,
      madani,
      jatalogo,
      // sun,
      // moon
    };
  },
  methods: {
    toggleGlobalSideBar() {
      this.$store.dispatch("ToggleGlobalSideBar");
    },
    toggleColorMode() {
      this.$store.dispatch("ToggleColorMode");
      this.tempColorMode = !this.tempColorMode
    },
    // login() {
    //   this.$router.push('/login')
    // },
    // register() {
    //   this.$router.push('/register')
    // },
    // dashboard() {
    //   this.$router.push('/dashboard')
    // },
    signIn() {
      this.$store.dispatch("OpenSignInPopup", { subscribe: false });
    },
    signInClose() {
      this.$store.dispatch("CloseSignInPopup");
    },
    branchLeave() {
      this.$store.dispatch("SetBranchSelected", null).then(() => {
        this.$store.dispatch("ClearRoutes").then(() => {
          this.$router.push("/projects");
        });
      });
    },
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        this.$store.dispatch("ResetRoutes").then(() => {
          this.$router.push("/?logout=true");
        });
      });
    },
    handleClickOutside() {
      this.$store.dispatch("CloseGlobalSideBar", { withoutAnimation: false });
    },
    google() {
      if (this.agePermission) {
        this.signInLoading = true;
      }
    },
    kick(route) {
      this.$router.push(route);
    },
    legal() {
      window.open('/legal')
    },
    privacy() {
      window.open('/privacy')
    },
    cookie() {
      window.open('/cookie')
    },
    searchBranch() {
      // console.log(this.branchSearch)
      // console.log(this.companies)
      this.branchLoading = true;
      this.filteredCompanies = this.companies.filter((company) => {
        return company && company.relationId && company.relationId.name ? company.relationId.name.toLowerCase().includes(this.branchSearch.toLowerCase()) : false;
      });
      // console.log(this.filteredCompanies)
      this.$nextTick(() => {
        this.branchLoading = false;
      })
    },
    resetForm() {
      this.userBranch = false;
      // this.currUser2 = {
      //   company: null,
      //   region: 0,
      //   branch: 0
      // }
    },
    async selectBranch() {
      // this.$store
      //   .dispatch(
      //     "SetBranchSelected",
      //     this.companies[this.currUser2.company].relationId.regions[this.currUser2.region]
      //       .branches[this.currUser2.branch]._id
      //   )
      //   .then(() => {
      //     // this.$store.dispatch("ClearRoutes").then(() => {
      //     //   this.$router.push("/bookings");
      //     // });
      //     location.reload();
      //     // this.$router.push("/");
      //   });
      this.userBranch = false;
			const index = this.filteredCompanies.findIndex((v) =>  v._id === this.currUser2.company)
      this.$router.push(`/z/${
        this.filteredCompanies[index].relationId.regions[this.currUser2.region]
          .branches[this.currUser2.branch]._id
      }/default?refresh=1`)
      // this.refreshPageAfter = true
      // this.$router.push('/account?refresh=true')
      this.currUser2 = {
        company: null,
        region: 0,
        branch: 0
      }
      // this.$router.push('/account')
      // location.reload();
    },
    nextBranch() {
      const companies = this.filteredCompanies
      let key = this.currUser2.company
      let item = null
      
      if (companies.length > 0) {
        // console.log("App Before")
        // console.log(this.$store.state.app.branchSelected)
        key = key + 1
        if (key == companies.length) {
          key = 0
        }
        item = companies[key]
        // console.log(item.relationId.regions[this.currUser2.region]
        //       .branches[this.currUser2.branch]._id)
        // console.log(servers)
        // console.log(key)
        // console.log(item)
        this.$store
          .dispatch(
            "GetBranch",
            companies[key].relationId.regions[this.currUser2.region]
              .branches[this.currUser2.branch]._id
          )
        // console.log("App After")
        // console.log(this.$store.state.app.branchSelected)
        this.currUser2.company = key
        // console.log("switch")
        // console.log(companies)
        // console.log(key)
        // console.log(item)
        // console.log(this.$store.state.user.branchData)
        return item.relationId.regions[this.currUser2.region]
              .branches[this.currUser2.branch]._id
      }
      return null
      // console.log("switch")
    },
    switchCompany() {
      this.userBranch = true;
      // console.log("this.filteredCompanies", this.filteredCompanies)
      if (this.filteredCompanies && this.filteredCompanies.length > 0 && this.$store.state.user.branchData) {
				const index = this.filteredCompanies.findIndex((v) => this.$store.state.user.branchData.relation && v._id === this.$store.state.user.branchData.relation._id)
				// console.log(index)
        this.currUser2.company = index !== null ? this.filteredCompanies[index]._id : null
				// console.log(this.currUser2.company)
      }
      // console.log("this.currUser2.company", this.currUser2.company)
    },
    log(key, message) {
      console.log(key, message)
    }
  },
  computed: {
    username() {
      return this.$store.state.user.username;
    },
    token() {
      return this.$store.state.user.token;
    },
    companies() {
      return this.$store.state.user.companies.sort((a, b) => {
        if (a.relationId && b.relationId) {
          if (a.relationId.name < b.relationId.name) {
            return -1
          }
          if (a.relationId.name > b.relationId.name) {
            return 1
          }
        }

        return 0
      });
    },
    globalSidebar() {
      return this.$store.state.app.globalSidebar;
    },
    branchData() {
      return this.$store.state.user.branchData
        ? this.$store.state.user.branchData
        : {};
    },
    mypetrolProfileData() {
      return this.$store.state.user.mypetrolProfileData
        ? this.$store.state.user.mypetrolProfileData
        : {};
    },
    branchLogo() {
      return this.$store.state.user.branchLogo;
    },
    features() {
      return this.$store.state.user.features;
    },
    branchSelected() {
      return this.$store.state.app.branchSelected;
    },
    signInPopup() {
      return this.$store.state.app.signInPopup;
    },
    device() {
      return this.$store.state.app.device;
    },
    isCollapse() {
      return !this.$store.state.app.globalSidebar.opened;
    },
    burgerAllowed() {
      return this.$store.state.app.burgerAllowed;
    },
    sidebarAllowed() {
      return this.$store.state.app.sidebarAllowed;
    },
    awakRole() {
      return this.$store.state.user.awakRole;
    },
    userData() {
      return this.$store.state.user.userData;
    },
    profilePicture() {
      return this.$store.state.user.profilePicture;
    },
    colorMode() {
      return this.$store.state.app.colorMode;
    },
    currentFeature() {
      // console.log("this.$store.state.user", this.$store.state.user)
      const features = this.$store.state.user.features
      const branchId = this.$route.params.branchId
      const mydiesel = features["mydiesel"]
      const mypetrol = features["mypetrol"]
      return branchId ? mypetrol ? "mypetrol" : mydiesel ? "mydiesel" : "mysubsidi" : "mysubsidi"
    },
    ...mapGetters(["permission_routers"])
  },
  filters: {
    roleFilter(val) {
      switch (val) {
        case 'kpdnadmin':
          return 'Admin'
        case 'miti':
          return 'KPDN'
        case 'Owner': {
          return 'User'
        }
        default:
          return val
      }
    },
    stringifyString(val) {
      console.log("val", val)
      if (val) {
        return JSON.stringify(val)
      }
      return val
    }
  },
  mounted() {
    // console.log('app branchSelected', this.$store.state.app.branchSelected)
    this.year = moment().format("YYYY");
    this.logo = null
    this.filteredCompanies = this.companies

    this.tempColorMode = this.colorMode === 1 ? true : false;

    if (this.colorMode) {
      document.documentElement.style.setProperty('--bg-color', "#111111");
      document.documentElement.style.setProperty('--bg2-color', "#000000");
      document.documentElement.style.setProperty('--bg3-color', "rgba(51,51,51,.9)");
      document.documentElement.style.setProperty('--bg4-color', "#222222");
      document.documentElement.style.setProperty('--bg5-color', "#333333");
      document.documentElement.style.setProperty('--bg6-color', "#00FF41");
      document.documentElement.style.setProperty('--bg7-color', "#666666");
      document.documentElement.style.setProperty('--bg8-color', "#111111");
      document.documentElement.style.setProperty('--bg9-color', "#353535");
      document.documentElement.style.setProperty('--bg10-color', "#111111");
      document.documentElement.style.setProperty('--bg11-color', "#00FF41");
      document.documentElement.style.setProperty('--bg12-color', "#000000");
      document.documentElement.style.setProperty('--bg13-color', "#000000");
      document.documentElement.style.setProperty('--primary-color', "#00FF41");
      document.documentElement.style.setProperty('--primary2-color', "#000000");
      document.documentElement.style.setProperty('--primary3-color', "#ffffff");
      document.documentElement.style.setProperty('--primary4-color', "#00FF41");
      document.documentElement.style.setProperty('--primary5-color', "#00FF41");
      document.documentElement.style.setProperty('--primary6-color', "#00FF41");
      document.documentElement.style.setProperty('--primary7-color', "#2caa4a");
      document.documentElement.style.setProperty('--primary8-color', "#00FF41");
      document.documentElement.style.setProperty('--primary9-color', "#000000");
      document.documentElement.style.setProperty('--primary10-color', "#000000");
      document.documentElement.style.setProperty('--primary11-color', "#000000");
      document.documentElement.style.setProperty('--secondary1-active-color', "#00FF41");
      document.documentElement.style.setProperty('--secondary1-inactive-color', "#00FF41");
      document.documentElement.style.setProperty('--secondary2-active-color', "#00FF41");
      document.documentElement.style.setProperty('--secondary2-inactive-color', "#00FF41");
      document.documentElement.style.setProperty('--secondary3-active-color', "#00FF41");
      document.documentElement.style.setProperty('--secondary3-inactive-color', "#DCDFE6");
      document.documentElement.style.setProperty('--secondary4-active-color', "#111111");
      document.documentElement.style.setProperty('--secondary4-inactive-color', "#00FF41");
      document.documentElement.style.setProperty('--secondary5-active-color', "#2caa4a");
      document.documentElement.style.setProperty('--secondary5-inactive-color', "#2caa4a");
      document.documentElement.style.setProperty('--secondary6-active-color', "#2e6555");
      document.documentElement.style.setProperty('--secondary6-inactive-color', "#00FF41");
      document.documentElement.style.setProperty('--table-border-color', "#333333");
    } else {
      document.documentElement.style.setProperty('--bg-color', "#ffffff");
      document.documentElement.style.setProperty('--bg2-color', "#000000");
      document.documentElement.style.setProperty('--bg3-color', "rgba(255,255,255,.9)");
      document.documentElement.style.setProperty('--bg4-color', "#EEEEEE");
      document.documentElement.style.setProperty('--bg5-color', "#EEEEEE");
      document.documentElement.style.setProperty('--bg6-color', "#273E95");
      document.documentElement.style.setProperty('--bg7-color', "#ffffff");
      document.documentElement.style.setProperty('--bg8-color', "#f3ad15");
      document.documentElement.style.setProperty('--bg9-color', "#273E95");
      document.documentElement.style.setProperty('--bg10-color', "#273E95");
      document.documentElement.style.setProperty('--bg11-color', "#273E95");
      document.documentElement.style.setProperty('--bg12-color', "#273E95");
      document.documentElement.style.setProperty('--bg13-color', "#d2dceb");
      document.documentElement.style.setProperty('--primary-color', "#000000");
      document.documentElement.style.setProperty('--primary2-color', "#000000");
      document.documentElement.style.setProperty('--primary3-color', "#000000");
      document.documentElement.style.setProperty('--primary4-color', "#d2dceb");
      document.documentElement.style.setProperty('--primary5-color', "#273E95");
      document.documentElement.style.setProperty('--primary6-color', "#ffffff");
      document.documentElement.style.setProperty('--primary7-color', "#ffffff");
      document.documentElement.style.setProperty('--primary8-color', "#f3ad15");
      document.documentElement.style.setProperty('--primary9-color', "#000000");
      document.documentElement.style.setProperty('--primary10-color', "#d2dceb");
      document.documentElement.style.setProperty('--primary11-color', "#273E95");
      document.documentElement.style.setProperty('--secondary1-active-color', "#C0C4CC");
      document.documentElement.style.setProperty('--secondary1-inactive-color', "#000000");
      document.documentElement.style.setProperty('--secondary2-active-color', "#909399");
      document.documentElement.style.setProperty('--secondary2-inactive-color', "#606266");
      document.documentElement.style.setProperty('--secondary3-active-color', "#5379f1");
      document.documentElement.style.setProperty('--secondary3-inactive-color', "#DCDFE6");
      document.documentElement.style.setProperty('--secondary4-active-color', "#ffffff");
      document.documentElement.style.setProperty('--secondary4-inactive-color', "#273E95");
      document.documentElement.style.setProperty('--secondary5-active-color', "#5379f1");
      document.documentElement.style.setProperty('--secondary5-inactive-color', "#000000");
      document.documentElement.style.setProperty('--secondary6-active-color', "#5379f1");
      document.documentElement.style.setProperty('--secondary6-inactive-color', "#5379f1");
      document.documentElement.style.setProperty('--table-border-color', "#EBEEF5");
    }
    // console.log("branchData", this.branchData)
    // if (this.branchData.logo) {
    //   this.logo = this.branchData.logo.path
    // }
    // console.log("branchData2", this.$store.state.user.branchData
    //     ? this.$store.state.user.branchData
    //     : {})
    // this.colorMode = false
    // console.log(this.$store.state.user.features)
    // if (this.$store.state.app.branchSelected) {
    //   this.notificationSocket = SocketIO.connect(process.env.BASE_API, {
    //     path: '/serviceNotifications-admin-socket.io',
    //     query: `token=${this.token}`
    //   })
    //   this.notificationSocket.on('connect', () => {
    //     console.log('connected')
    //     this.notificationSocket.emit('join', this.$store.state.app.branchSelected)
    //   })
    //   this.notificationSocket.on('newNotification', (data) => {
    //     console.log('app', data)
    //     this.$store.dispatch('GetUnreadMessages', this.$store.state.app.branchSelected)
    //   })
    // }
    // console.log(typeof this.notificationSocket)
    // console.log("company", this.currUser2.company)
    // console.log("branchData", this.$store.state.user.branchData)
    // console.log("filteredCompanies", this.filteredCompanies)
    // console.log("companies", this.companies)
  },
  // destroyed() {
  //   this.notificationSocket.disconnect()
  // },
  watch: {
    colorMode(to, from) {
      if (to === true) {
        document.documentElement.style.setProperty('--bg-color', "#111111");
        document.documentElement.style.setProperty('--bg2-color', "#000000");
        document.documentElement.style.setProperty('--bg3-color', "rgba(51,51,51,.9)");
        document.documentElement.style.setProperty('--bg4-color', "#222222");
        document.documentElement.style.setProperty('--bg5-color', "#333333");
        document.documentElement.style.setProperty('--bg6-color', "#00FF41");
        document.documentElement.style.setProperty('--bg7-color', "#666666");
        document.documentElement.style.setProperty('--bg8-color', "#111111");
        document.documentElement.style.setProperty('--bg9-color', "#353535");
        document.documentElement.style.setProperty('--bg10-color', "#111111");
        document.documentElement.style.setProperty('--bg11-color', "#f3ad15");
        document.documentElement.style.setProperty('--bg12-color', "#000000");
        document.documentElement.style.setProperty('--bg13-color', "#000000");
        document.documentElement.style.setProperty('--primary-color', "#00FF41");
        document.documentElement.style.setProperty('--primary2-color', "#000000");
        document.documentElement.style.setProperty('--primary3-color', "#ffffff");
        document.documentElement.style.setProperty('--primary4-color', "#00FF41");
        document.documentElement.style.setProperty('--primary5-color', "#00FF41");
        document.documentElement.style.setProperty('--primary6-color', "#00FF41");
        document.documentElement.style.setProperty('--primary7-color', "#2caa4a");
        document.documentElement.style.setProperty('--primary8-color', "#00FF41");
        document.documentElement.style.setProperty('--primary9-color', "#000000");
        document.documentElement.style.setProperty('--primary10-color', "#000000");
        document.documentElement.style.setProperty('--primary11-color', "#000000");
        document.documentElement.style.setProperty('--secondary1-active-color', "#00FF41");
        document.documentElement.style.setProperty('--secondary1-inactive-color', "#00FF41");
        document.documentElement.style.setProperty('--secondary2-active-color', "#00FF41");
        document.documentElement.style.setProperty('--secondary2-inactive-color', "#00FF41");
        document.documentElement.style.setProperty('--secondary3-active-color', "#00FF41");
        document.documentElement.style.setProperty('--secondary3-inactive-color', "#DCDFE6");
        document.documentElement.style.setProperty('--secondary4-active-color', "#111111");
        document.documentElement.style.setProperty('--secondary4-inactive-color', "#00FF41");
        document.documentElement.style.setProperty('--secondary5-active-color', "#2caa4a");
        document.documentElement.style.setProperty('--secondary5-inactive-color', "#2caa4a");
        document.documentElement.style.setProperty('--secondary6-active-color', "#2e6555");
        document.documentElement.style.setProperty('--secondary6-inactive-color', "#00FF41");
      document.documentElement.style.setProperty('--table-border-color', "#333333");
      } else {
        document.documentElement.style.setProperty('--bg-color', "#273E95");
        document.documentElement.style.setProperty('--bg2-color', "#000000");
        document.documentElement.style.setProperty('--bg3-color', "rgba(255,255,255,.9)");
        document.documentElement.style.setProperty('--bg4-color', "#EEEEEE");
        document.documentElement.style.setProperty('--bg5-color', "#273E95");
        document.documentElement.style.setProperty('--bg6-color', "#5379f1");
        document.documentElement.style.setProperty('--bg7-color', "#000000");
        document.documentElement.style.setProperty('--bg8-color', "#000000");
        document.documentElement.style.setProperty('--bg9-color', "#273E95");
        document.documentElement.style.setProperty('--bg10-color', "#273E95");
        document.documentElement.style.setProperty('--bg11-color', "#4F3932");
        document.documentElement.style.setProperty('--bg12-color', "#4F3932");
        document.documentElement.style.setProperty('--bg13-color', "#F3DAA2");
        document.documentElement.style.setProperty('--primary-color', "#ffffff");
        document.documentElement.style.setProperty('--primary2-color', "#ffffff");
        document.documentElement.style.setProperty('--primary3-color', "#ffffff");
        document.documentElement.style.setProperty('--primary4-color', "#F3DAA2");
        document.documentElement.style.setProperty('--primary5-color', "#000000");
        document.documentElement.style.setProperty('--primary6-color', "#ffffff");
        document.documentElement.style.setProperty('--primary7-color', "#ffffff");
        document.documentElement.style.setProperty('--primary8-color', "#783f04");
        document.documentElement.style.setProperty('--primary9-color', "#000000");
        document.documentElement.style.setProperty('--primary10-color', "#F3DAA2");
        document.documentElement.style.setProperty('--primary11-color', "#783f04");
        document.documentElement.style.setProperty('--secondary1-active-color', "#C0C4CC");
        document.documentElement.style.setProperty('--secondary1-inactive-color', "#303133");
        document.documentElement.style.setProperty('--secondary2-active-color', "#909399");
        document.documentElement.style.setProperty('--secondary2-inactive-color', "#606266");
        document.documentElement.style.setProperty('--secondary3-active-color', "#5379f1");
        document.documentElement.style.setProperty('--secondary3-inactive-color', "#DCDFE6");
        document.documentElement.style.setProperty('--secondary4-active-color', "#000000");
        document.documentElement.style.setProperty('--secondary4-inactive-color', "#273E95");
        document.documentElement.style.setProperty('--secondary5-active-color', "#5379f1");
        document.documentElement.style.setProperty('--secondary5-inactive-color', "#000000");
        document.documentElement.style.setProperty('--secondary6-active-color', "#5379f1");
        document.documentElement.style.setProperty('--secondary6-inactive-color', "#5379f1");
      document.documentElement.style.setProperty('--table-border-color', "#EBEEF5");
      }
    },
    branchLogo(to, from){
      this.logo = to
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$Tawk.$endChat();
    // console.log("beforeRouteLeave", to, from, next)
    // console.log(this.refreshPageAfter)
    // if (this.refreshPageAfter) {
    //   next(() => {
    //     location.reload();
    //   });
    // }
  }
};
</script>

<style lang="scss">
@import "./styles/variables.scss";
@font-face {
  font-family: College;
  src: url("./fonts/college/college.ttf");
}
@font-face {
  font-family: College;
  font-weight: bold;
  src: url("./fonts/college/collegeb.ttf");
}
@font-face {
  font-family: CaviarDreams;
  src: url("./fonts/caviar_dreams/CaviarDreams.ttf");
}
@font-face {
  font-family: CaviarDreams;
  font-weight: bold;
  src: url("./fonts/caviar_dreams/CaviarDreams_Bold.ttf");
}

.Cookie--kpdn {
  background-color: #fff;
  color: #000;
  padding: 1.25em;
}
.Cookie--kpdn .Cookie__button {
  border-radius: 4px;
  background: #000;
  padding: 0.625em 3.125em;
  color: #fff;
  border: 0;
  font-size: 1em;
}
.Cookie--kpdn .Cookie__button:hover {
  background: #000;
}
.Cookie--kpdn .Cookie__button:focus {
  background: #000;
}

.appLogo {
  max-height: 45px;
  max-width: 320px;
  @media (max-width: 430px) {
    max-width: 80px;
  }
  @media (max-width: 320px) {
    max-width: 50px;
  }
}
.normal-text {
  color: #000;
  padding: 20px 2%;
}

.hyperlink {
  color: cyan;
}

.Cookie--dark-lime {
  background-color: #fff;
  color: #000;
}
.Cookie--dark-lime .Cookie__button {
  background-color: #409eff;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  border-radius: 4px;
}
.Cookie--dark-lime .Cookie__button:hover {
  background-color: #409eff;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  border-radius: 4px;
}
.Cookie--dark-lime .Cookie__button:focus {
  background-color: #409eff;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  border-radius: 4px;
}

.headerClass {
  border-bottom-width: 1px;
  border-bottom-color: #e5e7eb;
  border-bottom-style: solid;
  height: 56px;
  padding: 0px 2% 0px 2%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  // background: linear-gradient(rgb(214, 217, 249), rgb(132, 132, 255));
  // background: linear-gradient(#7b88b8, #9ac9e4);
  background-color: #ffffff;
  .headerLink {
    display: block;
    font-size: 18px;
    color: var(--primary-color);
    padding-top: 15px;
    padding-right: 0px;
    padding-bottom: 16px;
    padding-left: 0px;
    text-align: center;
  }
  @media (max-width: 1024px) {
    padding: 0px 7% 0px 3%;
  }
}

.titleColor {
  color: $color1;
}
.titleColor:focus {
  color: $color1;
}
.titleColor:hover {
  color: $color1;
}
.rowTop {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 20px 0px 20px;
  height: auto;
  background-color: var(--bg-color);
}

.rowTop4 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0px 20px 20px 20px;
  // height: 96px;
  height: auto;
  background-color: var(--bg-color);
}

.companyList {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  background-color: var(--bg-color);
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  .companyButton {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    border-radius: 2px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    box-sizing: border-box;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
    p {
      text-align: center;
    }
  }
  .companyButton:hover {
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
  }
  .companyButton.inactive {
    border: 1px solid var(--primary4-color);
    background-color: var(--bg-color);
    color: var(--secondary2-inactive-color);
    cursor: pointer;
  }
  .companyButton.active {
    border: 1px solid var(--primary5-color);
    background-color: var(--primary5-color);
    color: var(--primary2-color);
    cursor: inherit;
  }
}

.colorModeDiv {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: var(--secondary3-inactive-color);
  position: absolute;
  right: 20px;
  .active {
    color: var(--secondary3-active-color);
  }
}

.el-dialog {
  margin-top: 5vh !important;
  margin-bottom: 15vh;
  border-style: solid;
  border-width: 4px;
  border-color: var(--v4-header-color);
  border-radius: 10px;
  .dialog-footer {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    .el-button {
      width: auto;
    }
    // .el-button.el-button--danger {
    //   padding: 15px 50px;
    // }
    @media (max-width: 459px){
    flex-direction: column; 
      .el-button {
        margin-left: 0px !important;
        margin-bottom: 10px !important;
        width: 100%;
      }
    }
  }
  .el-input__inner {
    // border-top-color: var(--el-form-item-dark);
    // border-left-color: var(--el-form-item-dark);
    // border-right-color: var(--el-form-item-dark);
    // border-bottom-color: var(--el-form-item-light);
    // border-top-color: #e5e7eb;
    // border-left-color: #e5e7eb;
    // border-right-color: #e5e7eb;
    // border-bottom-color: #e5e7eb;
    border-top-color: rgb(218, 218, 218);
    border-left-color: rgb(218, 218, 218);
    border-right-color: rgb(218, 218, 218);
    border-bottom-color: rgb(218, 218, 218);
    // border-width: 2px;
    border-width: 2px;
    border-radius: 5px;
    border-style: solid;
  }
  .el-textarea__inner {
    border-color: rgb(133, 133, 133);
  }
  .el-button {
    font-family: 'Inter', sans-serif;
  }
  .el-input-number__decrease {
    border-color: rgb(133, 133, 133);
  }
  .el-input-number__increase {
    border-color: rgb(133, 133, 133);
  }
  .el-dialog__header {
    .el-dialog__title {
      font-size: 28px;
      line-height: 28px;
    }
  }
  .el-dialog__body {
    word-break: normal;
    padding-top: 0px;
  }
  .bigLabel {
    .el-form-item__label {
      font-size: 20px;
      line-height: 40px;
      margin-bottom: 10px;
    }
    .normalLabel {
      .el-form-item__label {
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 0px;
      }
    }
  }
  .el-form-item {
    display: flex;
    flex-direction: column;
  }
  .el-form-item__label {
    color: var(--darker-border-color);
    width: 100%;
    text-align: left;
    line-height: 20px;
  }
  .el-form-item__content {
    color: var(--darker-border-color);
    margin-left: 0px;
    .el-date-editor.el-input {
      width: 100%;
    }
  }
  .row {
    flex-direction: row;
    .el-form-item__label {
      width: auto;
    }
    .el-form-item__content {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  @media screen and (max-width: 870px) {
    margin-top: 2vh !important;
    margin-bottom: 2vh !important;
    width: 90%;
  }
}

.el-textarea__inner {
  font-family: 'Inter', sans-serif;
  color: var(--v4-dark-font-color);
  // border-top-color: var(--el-form-item-dark);
  // border-left-color: var(--el-form-item-dark);
  // border-right-color: var(--el-form-item-dark);
  // border-bottom-color: var(--el-form-item-light);
  // border-top-color: #e5e7eb;
  // border-left-color: #e5e7eb;
  // border-right-color: #e5e7eb;
  // border-bottom-color: #e5e7eb;
    border-top-color: rgb(218, 218, 218);
    border-left-color: rgb(218, 218, 218);
    border-right-color: rgb(218, 218, 218);
    border-bottom-color: rgb(218, 218, 218);
  // border-width: 2px;
  border-width: 2px;
  border-radius: 5px;
  border-style: solid;
}
.el-textarea__inner:hover {
  border-color: var(--v4-darkest-border-content);
}
.el-input__inner {
  font-family: 'Inter', sans-serif;
  color: var(--v4-dark-font-color);
  // border-top-color: var(--el-form-item-dark);
  // border-left-color: var(--el-form-item-dark);
  // border-right-color: var(--el-form-item-dark);
  // border-bottom-color: var(--el-form-item-light);
  // border-top-color: #e5e7eb;
  // border-left-color: #e5e7eb;
  // border-right-color: #e5e7eb;
  // border-bottom-color: #e5e7eb;
  border-top-color: rgb(218, 218, 218);
  border-left-color: rgb(218, 218, 218);
  border-right-color: rgb(218, 218, 218);
  border-bottom-color: rgb(218, 218, 218);
  // border-width: 2px;
  border-width: 2px;
  border-radius: 5px;
  border-style: solid;
}
.el-input__inner:hover {
  border-color: var(--v4-darkest-border-content);
}
.el-input__suffix {
  color: #000;
}
.el-input-number__decrease {
  font-family: 'Inter', sans-serif;
  color: var(--darker-border-color);
  border-color: var(--bg6-color);
}
.el-input-number__increase {
  font-family: 'Inter', sans-serif;
  color: var(--darker-border-color);
  border-color: var(--bg6-color);
}
.border2px {
  input {
    border-width: 2px;
  }
}
::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #f0f;
}

.el-button {
  font-family: 'Inter', sans-serif;
  // margin-bottom: 10px;
  font-size: 14px;
  border-width: 1px;
  border-style: solid;
  padding: 10px 12px;
}
// .el-button:hover {
  // border-top-width: 4px;
  // border-bottom-width: 0px;
  // border-left-width: 2px;
  // border-right-width: 2px;
// }
.el-button+.el-button {
  margin-left: 10px;
}
.el-button.is-disabled {
  color: var(--v4-darkest-disabled);
  // padding: 15px 60px;
  background: linear-gradient(var(--v4-light-disabled), var(--v4-lightest-disabled));
  border-color: var(--v4-light-disabled);
  border-top-color: var(--v4-dark-disabled);
}
.el-button.is-disabled:hover {
  color: var(--v4-darkest-disabled);
  background: linear-gradient(var(--v4-light-disabled), var(--v4-lightest-disabled));
  border-color: var(--v4-light-disabled);
  border-top-color: var(--v4-dark-disabled);
}
.el-button.padded {
  // padding: 15px 60px;
}
.el-button.small {
  padding: 0px 15px;
  height: 50px;
  @media (max-width: 426px){
    padding: 0px 5px;
  }
}
.el-button.smaller {
  padding: 5px 5px;
  // height: 40px;
  margin: 0px;
  font-size: 13px;
}
.el-button--primary {
  color: var(--light-font-color);
  font-weight: 500;
  // font-size: 15px;
  border-radius: 5px;
  // padding: 15px 60px;
  background: linear-gradient(var(--v4-login-button-light), var(--v4-login-button));
  border-top-color: var(--v4-login-button-lightest);
  border-bottom-color: var(--v4-login-button-darkest);
  border-left-color: var(--v4-login-button-light);
  border-right-color: var(--v4-login-button-dark);
}
.el-button--primary:focus, .el-button--primary:hover {
  background: linear-gradient(var(--v4-login-button), (var(--v4-login-button-mid)));
  // border-top-color: var(--v4-login-button-lightest);
  // border-bottom-color: var(--v4-login-button-darkest);
  // border-left-color: var(--v4-login-button-light);
  // border-right-color: var(--v4-login-button-dark);
}
.el-button--secondary {
  color: var(--el-button-darkest);
  font-weight: 300;
  // font-size: 15px;
  border-radius: 5px;
  // padding: 15px 60px;
  background-color: var(--el-button);
  border-top-color: var(--el-button-light);
  border-bottom-color: var(--el-button-dark);
  border-left-color: var(--el-button-dark);
  border-right-color: var(--el-button-dark);
}
.el-button--secondary:focus, .el-button--secondary:hover {
  color: var(--v4-dark-font-color);
  background-color: var(--el-button-mid);
  border-top-color: var(--el-button-dark);
  border-bottom-color: var(--el-button-darkest);
  border-left-color: var(--el-button-dark);
  border-right-color: var(--el-button-dark);
}
.el-button--transparent {
  color: var(--darkest-border-color);
  font-weight: 500;
  font-size: 15px;
  border-radius: 5px;
  // padding: 15px 60px;
  background-color: transparent;
  border-top: solid 2px var(--v4-login-button-lightest);
  border-left: solid 2px var(--v4-login-button-darkest);
  border-bottom: solid 2px var(--darker-border-color);
  border-right: solid 2px var(--darker-border-color);
}
.el-button--transparent:focus, .el-button--transparent:hover {
  color: var(--darkest-border-color);
  background-color: rgba(65, 97, 186, 0.027);
  border-top: solid 3px var(--v4-login-button-lightest);
  border-left: solid 2px var(--v4-login-button-darkest);
  border-bottom: solid 1px var(--darker-border-color);
  border-right: solid 2px var(--darker-border-color);
}
.el-button--trio {
  color: var(--light-font-color);
  text-shadow: 0px 0px 2px 0px var(--light-font-color);
  font-weight: 500;
  font-size: 15px;
  border-radius: 5px;
  // padding: 15px 60px;
  background: linear-gradient(to right, rgb(3, 23, 132), var(--nimp-gray));
  border-top: solid 2px var(--v4-login-button-lightest);
  border-bottom: solid 2px var(--v4-login-button-darkest);
  border-left: solid 2px var(--v4-login-button-light);
  border-right: solid 2px var(--v4-login-button-dark);
}
.el-button--trio:focus, .el-button--trio:hover {
  color: var(--light-font-color);
  background: linear-gradient(to right, rgb(2, 15, 85), rgb(68, 68, 68));
  border-top: solid 4px var(--v4-login-button-lightest);
  border-bottom: solid 0px var(--v4-login-button-darkest);
  border-left: solid 2px var(--v4-login-button-lightest);
  border-right: solid 2px var(--v4-login-button-lightest);
}
.el-button--beige {
  background-color: var(--login-button);
  border-color: var(--login-button);
  color: var(--light-font-color);
  margin-bottom: 0px;
}
.el-button--beige:focus, .el-button--beige:hover {
  background-color: var(--tritary-color);
  border-color: var(--tritary-color);
  color: #fff;
}
.el-button--dark {
  color: var(--light-font-color);
  background: linear-gradient( var(--v4-login-button-mid), (var(--v4-login-button-mid)));
  border-top-color: var(--v4-login-button-lightest);
  border-bottom-color: var(--v4-login-button-darkest);
  border-left-color: var(--v4-login-button-lightest);
  border-right-color: var(--v4-login-button-lightest);
  border-width: 2px;
  border-style: solid;
}
.el-button--dark:focus, .el-button--dark:hover {
  color: var(--light-font-color);
  background: linear-gradient( var(--v4-login-button-mid), (var(--v4-login-button-mid)));
  border-top-width: 4px;
  border-bottom-width: 0px;
  border-left-width: 2px;
  border-right-width: 2px;
}
.el-button--danger {
  background: linear-gradient(#eb5571, #ff7d8a);
  border-top-color: var(--light-danger);
  border-left-color: var(--light-danger);
  border-bottom-color: var(--darker-danger);
  border-right-color: var(--darker-danger);
  border-width: 2px;
  border-style: solid;
  color: #ffffff;
}
.el-button--danger:hover {
  background: linear-gradient(#eb5571, #eb5571);
  background-color: var(--darker-danger);
  border-top-color: var(--light-danger);
  border-left-color: var(--light-danger);
  border-bottom-color: var(--darker-danger);
  border-right-color: var(--darker-danger);
  border-top-width: 4px;
  border-bottom-width: 0px;
  border-left-width: 2px;
  border-right:-width 2px;
}
.el-button--success {
  background: linear-gradient(#49b59c, #5ed194);
  border-top-color: var(--light-success);
  border-left-color: var(--light-success);
  border-bottom-color: var(--darker-success);
  border-right-color: var(--darker-success);
}
.el-button--success:hover {
  background: linear-gradient(#49b59c, #49b5a8);
  background-color: var(--darker-success);
  border-color: var(--light-success);
}
.el-button--warning {
  border-color: var(--darker-border-color);
  background-color: var(--darker-border-color);
  color: var(--primary2-color);
}
.el-button--warning:focus, .el-button--warning:hover {
  border-color: var(--darker-border-color);
  background-color: var(--darker-border-color);
  color: var(--primary2-color);
}

.el-collapse {
  border-color: var(--bg6-color);
}
.el-collapse-item__header {
  border-color: var(--bg6-color);
  background-color: #fff4cd;
  color: var(--darker-border-color);
}
.el-collapse-item__wrap {
  border-color: var(--bg6-color);
  background-color: var(--bg-color);
}

.el-tag--lightfill {
  padding: 0px 0px;
  background-color: #fff;
  border-bottom-color: var(--darker-border-color);
  border-top-color: var(--light-border-color);
  color: var(--darkest-border-color);
  font-style: italic;
  transition: 0.3s;
}

.loginstaff-button {
  display: inline-flex;
  color: var(--light-font-color);
  text-shadow: 0px 0px 2px 0px var(--light-font-color);
  font-weight: 500;
  font-size: 15px;
  border-radius: 5px;
  padding: 5px;
  background-color: var(--pure-blue);
  transition: 0.2s;
  justify-content: space-between;
  cursor: pointer;
  .logo-container {
    background-color: #fff; 
    height: 40px; 
    width: 40px; 
    border-radius: 2px; 
    display: flex; 
    justify-content: center; 
    align-items: center;
    img {
      height: 30px; 
    }
  }
  .text-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 85%;
  }
}
.loginstaff-button:focus, .loginstaff-button:hover {
  background-color: var(--v4-login-button-light);
}

/*Fixes double tap on iOS*/
.el-scrollbar__bar {
  opacity: 1!important;
}

.el-progress {
  margin-bottom: 2px;
  transition: 0.2s;
}
.el-progress-bar {
  width: 100%;
  max-width: 500px;
  min-width: 400px;
  .el-progress-bar__outer {
    // border: solid 1px var(--light-border-color);
    width: 100%;
    background-color: #ffffff;
    border-top: solid 2px var(--main-border-color);
    border-bottom: solid 2px var(--darker-border-color);
    border-left: solid 2px var(--main-border-color);
    border-right: solid 2px var(--main-border-color);
    height: 40px !important;
    transition: 0.2s;
  }
  .el-progress-bar__inner {
    background-image: linear-gradient(to right, var(--v4-login-button-mid), var(--v4-login-button-light));
    border-top: solid 2px var(--v4-login-button-light);
    border-bottom: solid 2px var(--v4-login-button-darkest);
  }
  .el-progress-bar__innerText {
    color: #FFF;
    font-size: 14px;
    font-weight: 600;
  }
  @media (max-width: 459px) {
    min-width: 200px;
  }
}
.el-progress:hover .el-progress-bar__outer{
  border-top: solid 0px var(--main-border-color);
  border-bottom: solid 4px var(--darker-border-color);
}

.el-progress.zero {
  .el-progress-bar__innerText {
    color: var(--darkest-border-color);
    font-weight: 300;
  }
}

.el-radio-group {
  margin-bottom: 20px;
  .el-radio__label {
    font-size: 16px;
    line-height: 20px;
    word-break: keep-all; 
    white-space: nowrap; 
    overflow: hidden; 
    text-wrap: wrap;
  } 
  .el-radio__inner {
    border-color: var(--darker-border-color);
  }
  .el-radio.is-checked .el-radio__label{
    color: var(--v4-login-button-mid);
  }
  .el-radio.is-checked .el-radio__inner {
    background-color: var(--v4-login-button-mid);
    border-color: var(--v4-login-button-mid);
  }
}
.el-checkbox-group {
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  line-height: 1px;
  margin-bottom: 20px;
}
.el-checkbox {
  line-height: 12px;
}
.el-checkbox__label {
  font-size: 16px;
  line-height: 16px;
  word-break: break-word; 
  white-space: nowrap; 
  overflow: hidden; 
  text-wrap: wrap;
  padding-left: 20px;
}
.el-checkbox__inner {
  border-color: var(--darker-border-color);
  margin-bottom: 8px;
  line-height: 12px;
  position: absolute !important;
}
.el-checkbox__input {
  vertical-align: top;
}
.el-checkbox__input.is-checked+.el-checkbox__label {
  width: 100%;
  word-wrap: break-word;
  word-break: keep-all;
  overflow: hidden;
  color: var(--v4-login-button-mid);
}
.el-checkbox__input.is-disabled+span.el-checkbox__label {
  color: #C0C4CC;
}
.el-checkbox__input.is-disabled.is-checked+span.el-checkbox__label {
  color: var(--v4-login-button-mid);
}
.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: var(--v4-login-button-mid);
  border-color: var(--v4-login-button-mid);
}
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: var(--v4-login-button-mid);
  border-color: var(--v4-login-button-mid);
}

.profileForm {
  width: 100%;
  justify-content: center;
  .el-form-item {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: start;
    flex-direction: column;
    margin-bottom: 10px;
    .el-form-item__label {
      text-align: left;
      vertical-align: middle;
      width: 100%;
      font-size: 17px;
      font-weight: 300;
      line-height: 17px;
      color: var(--v4-dark-font-color);
      padding: 6px 12px 0 0;
      margin-bottom: 8px;
    }
    .el-form-item__content {
      margin-left: 0px;
      width: 100%;
    }
    .el-input {
      width: 100%;
    }
    .el-select {
      width: 100%;
    }
    .ignore {
      .el-input {
        width: 100%;
      }
    }
  }

  .avatarUploader {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatarUploader:hover {
    border-color: #409EFF;
  }
  .avatarUploaderIcon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
    top: 0px;
    position: absolute;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  @media screen and (max-width: 768px) {
    .el-form-item__label {
      font-size: 16px !important;
      line-height: 16px !important;
      padding: 12px 12px 0 0 !important;
    }
    .el-form-item__content {
      margin-left: 140px
    }
    .el-input {
      width: 100%;
    }
    .avatarUploaderIcon {
      width: 140px;
      height: 140px;
      line-height: 140px;
    }
    .avatar {
      width: 140px;
      height: 140px;
    }
  }
}
.profileForm.extraMargin {
  .el-form-item {
    margin-bottom: 20px;
  }
}

input[type="checkbox"] {
  cursor: pointer;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  outline: 0;
  background: #fff;
  height: 12px;
  width: 12px;
  display: flex;
  margin-top: 5px !important;
  margin-bottom: 5px !important;
  border: 1px solid #767676;
  color: var(--primary2-color);
  border-radius: 2px;
  justify-content: center;
  align-items: center;
}

input[type="checkbox"]:checked {
  background: var(--primary5-color);
  border: 1px solid var(--primary5-color);
  color: var(--primary2-color);
}

input[type="checkbox"]:after {
  content: ' ';
  position: relative;
  left: 0%;
  top: 0%;
  width: 15%;
  height: 40%;
  border: solid var(--primary2-color);
  border-width: 0 2px 2px 0;
  transform: rotate(50deg);
  display: none;
}

input[type="checkbox"]:checked:after {
  display: block;
}


.footerClass {
  display: flex;
  flex-direction: row;
  width: 100%;
  // min-height: 128px;
  // min-height: 320px;
  height: 100%;
  box-sizing: border-box;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  color: var(--darkest-border-color);
  background-color: rgb(248, 250, 252);
  border-top: 1px solid #e5e7eb;
  padding: 24px 16px 72px 16px;
  font-family: 'Inter', Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
  // z-index: 999;
  .footerflexwrap {
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: row;
    align-items: start;
    flex-wrap: wrap;
    overflow: hidden;
  }
}
.footerClass.normal {
  padding: 24px 16px 24px 16px;
}

.tagButton {
  display: flex; 
  justify-content: center; 
  align-items: center;
  border-width: 1.5px !important;
  border-style: solid;
  border-top-color: var(--v4-login-button-lightest);
  border-left-color: var(--el-button-light);
  border-bottom-color: var(--darker-border-color);
  border-right-color: var(--darker-border-color);
  font-size: 12px;
  // width: 80px;
  // height: 32px;
  width: auto;
  height: auto;
  margin-left: 2px !important;
  margin-right: 0px;
  margin-top: 0px;
  margin-bottom: 0px;
  padding: 10px 10px;
  transition: 0.1s;
}
.tagButton:hover {
  border-color: var(--darker-border-color);
  border-top-width: 1px; 
  border-bottom-width: 2px; 
}

.addButton {
  display: flex;
  position: fixed;
  z-index: 1010;
  width: 80px;
  height: 80px;
  bottom: 20px;
  right: 20px;
  padding: 0px;
  justify-content: center;
  align-items: center;
  font-size: 48px;
  // color: var(--primary2-color);
  // background-color: var(--bg6-color);
}
.addButtonParent {
  display: flex;
  position: fixed;
  z-index: 1010;
  bottom: 20px;
  right: 20px;
  padding: 0px;
  justify-content: center;
  align-items: center;
  border: 2px solid var(--v4-login-button-lightest);
  border-radius: 50%;
}
.addButtonParent2 {
  display: flex;
  position: fixed;
  z-index: 1010;
  bottom: 120px;
  right: 20px;
  padding: 0px;
  justify-content: center;
  align-items: center;
  border: 2px solid var(--v4-login-button-lightest);
  border-radius: 50%;
}

.addButtonChicken {
  display: flex;
  position: relative;
  width: 80px;
  height: 80px;
  padding: 0px;
  justify-content: center;
  align-items: center;
  font-size: 48px;
  // border-color: var(--bg-color) !important;
  border-radius: 50%;
  // color: var(--primary10-color);
  // background-color: var(--v4-dark-font-color);
  color: var(--light-font-color);
  // font-weight: 500;
  // font-size: 15px;
  // border-radius: 5px;
  // // padding: 15px 60px;
  background: linear-gradient(var(--v4-login-button), var(--v4-login-button-mid), (var(--v4-login-button-light)));
  border-top: solid 2px var(--v4-login-button-lightest);
  border-bottom: solid 2px var(--v4-login-button-darkest);
  border-left: solid 2px var(--v4-login-button-dark);
  border-right: solid 2px var(--v4-login-button-dark);
}
.addButtonChicken:hover {
  background: linear-gradient(var(--v4-login-button), (var(--v4-login-button-mid)));
  border-top: solid 4px var(--v4-login-button-lightest);
  border-bottom: solid 0px var(--v4-login-button-darkest);
  border-left: solid 2px var(--v4-login-button-lightest);
  border-right: solid 2px var(--v4-login-button-lightest);
}
.addButton.el-button.is-round {
  border-radius: 50%;
}

.homeBody {
  min-height: 100%;
  min-width: 100%;
  .el-form-item__content {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    // background-color: var(--bg7-color);
    .svg-container {
      margin-left: 10px;
      color: var(--v4-login-button-darkest);
    }
    .show-pwd {
      color: var(--v4-dark-font-color);
      padding: 0px 10px 0px 0px;
      cursor: pointer;
      animation: 0.2s transform;
    }
    .show-pwd.bigger{
      padding: 0px 10px 0px 10px;
    }
    .show-pwd:hover {
      transform: scale(1.1);
    }
  }
  .homeLogo {
    height: 140px;
  }
  .box {
    display: flex;
    position: relative;
    align-items: flex-start;
    justify-content: center;
    background-color: $color4;
    width: 100%;
    height: 100%;
    min-height: 500px;
    overflow: hidden;
  }

  .box1 {
    background-position: center top;
    background-repeat: no-repeat;
    background-size: cover;
    animation-name: expandscreen;
    animation-fill-mode: both;
    animation-delay: 0.2s;
    animation-duration: 4s;
    position: relative;
    // background-image: url('../../assets/accounting-black.png');
  }

  .homeLogoDiv {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    max-width: 1020px;
    min-width: 0px;
    margin-top: 10px;
    // margin-right: 5px;
    // border: 1px #ccc solid;
    z-index: 2;
    position: relative;
  }

  .homeContainerDiv {
    display: flex;
    position: relative;
    width: 480px;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 0px 40px;
  }

  .colorModeOverlay {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    color: var(--secondary3-inactive-color);
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 999;
    .active {
      color: var(--secondary3-active-color);
    }
    @media (max-width: 928px){
      top: 100px;
    }
    @media (max-width: 599px){
      top: 170px;
    }
    // @media (max-width: 462px){

    // }
  }

  .homePage {
    position: relative;
    display: flex;
    width: 1020px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: #ffffff;
    min-height: 100vh;
    @media (max-width: 882px){
      width: 100%;
    }
  }

  .homeLoginContainerDiv {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    max-width: 1020px;
    min-width: 0px;
    z-index: 2;
    transition: 0.3s;
  }
    
  .homeLoginDiv {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    position: relative;
    width: 100%;
    min-width: 0px;
    max-width: 500px;
    transition: 0.3s;
    height: 100%;
    margin-top: 0px;
    margin-bottom: 0px;
    border-radius: 4px;
    background-color: #fff;
    // border-top: solid 5px var(--v4-lightest-border-content);
    // border-bottom: solid 5px var(--v4-darkest-border-content);
    // border-left: solid 5px var(--v4-light-border-content);
    // border-right: solid 5px var(--v4-darkest-border-content);
    border-top: 1px solid #e5e7eb;
    border-bottom: 1px solid #e5e7eb;
    border-left: 1px solid #e5e7eb;
    border-right: 1px solid #e5e7eb;
    padding: 10px 10px;
    // box-shadow: 0px 0px 8px 1px var(--v4-dark-box-shadow-color);
    .homeOverlay {
      display: flex;
      left: -2px;
      position: absolute;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width: 100%;
      height: 100%;
      border-radius: 5px;
      overflow: hidden;
      .homePixBg {
        display: flex;
        position: absolute;
        width: 100%;
        height: 100%;
        opacity: 0.6;
        transition:  0.7s;
        object-fit: cover;
        object-position: 50% 50%;
        border-radius: 5px;
        animation-name: expandcardpixbg;
        animation-delay: 0s;
        animation-duration: 5s;
        animation-timing-function: cubic-bezier(.08,.44,.51,.98);
        animation-fill-mode: backwards;
      }
    }
    .homeForeground {
      display: flex;
      position: relative;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width: 100%;
      height: 100%;
      z-index: 2;
    }
    .homeTitle {
      width: 100%;
      height: 20px;
      font-size: 20px;
      font-weight: 400;
      // text-decoration-line: underline;
      margin: 30px 0px 10px 0px;
      text-align: center;
      color: var(--v4-dark-font-color);
      // text-shadow: 0px -1px 0px var(--v4-lightest-border-content);
    }
    .titleLine {
      display: flex;
      position: absolute;
      top: 50px;
      left: 20px;
      width: calc(100% - 40px);
    }
    .el-input {
      display: inline-block;
      height: 47px;
      width: 85%;
      input {
        //background: transparent;
        border: 0px;
        // -webkit-appearance: none;
        border-radius: 0px;
        padding: 12px 5px 12px 15px;
        //color: $light_gray;
        background-color: var(--bg7-color);
        color: var(--v4-dark-font-color);
        height: 47px;
        &:-webkit-autofill {
          -webkit-box-shadow: 0 0 0px 1000px var(--bg7-color) inset !important;
          //-webkit-text-fill-color: #fff !important;
        }
      }
    }
    // .el-button:focus {
    //   background-color: var(--v4-login-button-dark);
    //   border-top: solid 10px var(--v4-login-button-light);
    //   border-bottom: solid 0px var(--v4-login-button-dark);
    // }
    @media (max-width: 768px){
      padding: 0px 0px;
    }
  }

  .homeMultipleDiv {
    display: flex; 
    flex-direction: column; 
    justify-content: center; 
    align-items: center;
    position: relative;
    width: 100%; 
    background-color: var(--bg2-color);
    z-index: 1;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 0px;
    padding-bottom: 0px;
    .fadeGradient {
      display: flex;
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 480px;
      object-fit: fill;
      z-index: -1;
    }

    .homePlatformDiv {
      display: flex; 
      flex-direction: column; 
      justify-content: center; 
      align-items: center; 
      width: 100%; 
      background-color: var(--bg9-color);
      .multipleBorder2 {
        display: flex; 
        flex-direction: column; 
        justify-content: center; 
        align-items: center;
        width: 100%;
        height: 100%;
        border: 8px solid var(--secondary5-active-color);
        padding-top: 20px;
        padding-bottom: 20px;
        .platformTitle {
          color: var(--primary-color);
          font-size: 64px;
          font-weight: bold;
          margin-top: 0px;
          margin-bottom: 0px;
        }
      }
    }
      
    .multipleBorder1 {
      display: flex; 
      flex-direction: column; 
      justify-content: center; 
      align-items: center;
      width: 100%;
      height: 100%;
      border: 4px solid var(--secondary5-inactive-color);
      padding-left: 40px;
      padding-right: 40px;
      padding-top: 40px;
      padding-bottom: 40px;
      .multipleText {
        display: flex;
        flex-direction: column; 
        justify-content: center; 
        align-items: center;
        width: 100%;
        margin-bottom: 10px;
        p {
          margin-top: 0px;
          margin-bottom: 0px;
          color: var(--primary7-color);
          .multipleHighlight {
            color: var(--secondary6-inactive-color);
          }
        }
        .multipleTop {
          font-size: 42px;
          text-align: left;
        }
        .multipleBottom {
          font-size: 64px;
          text-align: left;
        }
      }
      .userFlow {
        display: flex;
        width: 100%;
        max-width: 1200px;
        margin-bottom: 0px;
        object-fit: contain;
      }
    }
  }

  .homeInfoDiv {
    display: block; 
    flex-direction: column; 
    justify-content: center; 
    align-items: center;
    position: relative;
    width: 100%;
    min-width: 1022px;
    // height: 100vh;
    height: 575px;
    overflow: hidden;
    background-color: var(--secondary5-inactive-color);
    border-top: 0px;
    .iframeWrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      // width: 100%;
      // height: calc(100vh + 36px);
      // width: 1022px;
      // height: calc(575px + 36px);
      width: 100%;
      height: calc(100% + 36px);
      span {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 0px;
        top: 0px;
        z-index: 999;
        width: 100%;
        height: 100%;
        color: #fff;
      }
      iframe {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .iframeFinger {
      display: flex;
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
      z-index: 2;
    }
    .infoTitle {
      width: 100%;
      color: var(--primary6-color);
      text-align: center;
      font-size: 72px;
      margin-top: 0px;
      margin-bottom: 0px;
    }
    .infoSubtext {
      width: 100%;
      color: var(--primary6-color);
      text-align: center;
      font-size: 24px;
      margin-top: 0px;
      margin-bottom: 0px;
      line-height: 1;
    }
    .infoGroup {
      display: flex; 
      flex-direction: row;
      margin-top: 80px;
      width: 100%;
      .infoText {
        display: flex; 
        flex: 1;
        flex-direction: column; 
        justify-content: center; 
        width: 50%;
        margin-top: 40px;
        margin-bottom: 40px;
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 20px;
        padding-bottom: 20px;
        p {
          font-size: 68px;
          text-align: right;
          margin-top: 0px;
          margin-bottom: 0px;
          color: var(--primary6-color);
          .sellHighlight {
            color: var(--primary7-color);
          }
        }
      }
      .left {
        border-right: 4px solid var(--primary6-color);
        align-items: flex-end;
        p {
          text-align: right;
        }
      }
      .right {
        border-left: 4px solid var(--primary6-color);
        align-items: flex-start;
        p {
          text-align: left;
        }
      }
    }
  }

  .homeFeaturesDiv {
    display: flex; 
    flex-direction: column; 
    justify-content: center; 
    align-items: center; 
    width: 100%; 
    background-color: var(--secondary4-inactive-color);
    border-bottom: 12px solid #000000;
    padding-top: 20px;
    padding-bottom: 20px;
    .featureTitle {
      font-size: 76px;
      margin-top: 0px;
      margin-bottom: 0px;
      color: #276239;
    }
  }

  .homeProductDiv {
    display: flex; 
    flex-direction: row; 
    justify-content: space-around; 
    align-items: center; 
    width: 100%; 
    border-top: 4px solid var(--primary4-color);
    flex-wrap: wrap; 
    overflow: hidden;
    .homeProduct {
      display: flex; 
      align-items: center; 
      width: 50%;
      padding-top: 40px;
      padding-bottom: 40px;
      font-size: 320px;
      .svg-icon {
        display: flex;
        flex: 1;
        width: 100%;
        max-width: 320px;
      }
      img {
        height: 100px;
      }
      .textSection {
        display: flex;
        flex-direction: column;
        border-width: 4px;
        border-style: solid;
        padding: 20px;
        margin-left: 20px;
        margin-right: 20px;
        width: 240px;
        height: 380px;
        border-radius: 20px;
        p {
          font-size: 36px;
          margin-top: 0px;
          margin-bottom: 0px;
        }
      }
    }
    .left {
      justify-content: flex-end;
      .textSection {
        margin-left: 60px;
      }
    }
    .right {
      justify-content: flex-start;
      flex-direction: row;
      .textSection {
        margin-right: 60px;
      }
    }
    .white {
      background-color: var(--secondary4-active-color);
      color: var(--secondary3-active-color);
      .textSection {
        border-color: var(--secondary6-active-color);
        color: var(--primary5-color);
      }
    }
    .black {
      background-color: var(--secondary3-active-color);
      color: var(--secondary4-active-color);
      .textSection {
        border-color: var(--primary2-color);
        color: var(--primary2-color);
      }
    }
  }
}
.homeBody.formItemBorder {
  .el-form-item {
    // border-top: var(--el-form-item-dark);
    // border-left: var(--el-form-item-dark);
    // border-right: var(--el-form-item-dark);
    // border-bottom: var(--el-form-item-light);
    // border-top-color: #e5e7eb;
    // border-left-color: #e5e7eb;
    // border-right-color: #e5e7eb;
    // border-bottom-color: #e5e7eb;
    border-top-color: rgb(218, 218, 218);
    border-left-color: rgb(218, 218, 218);
    border-right-color: rgb(218, 218, 218);
    border-bottom-color: rgb(218, 218, 218);
    // border-width: 2px;
    border-width: 2px;
    border-style: solid;
    border-radius: 5px;
    transition: 0.3s;
    .svg-icon {
      color: var(--v4-dark-font-color);
    }
    .el-input__inner {
      border: 0px;
    }
  }
  .el-form-item:hover {
    border-color: var(--v4-darkest-border-content);
  }
}
.homeBody.scroll {
  overflow: scroll;
}
.el-tooltip__popper.is-light {
  // background: linear-gradient(45deg, #ff0000, #ff7f00, #ffff00, #00ff00, #0000ff, #4b0082, #8b00ff);
  background-color: #fffffff2;
  border-color: var(--darker-border-color);
  color: var(--v4-dark-font-color);
  max-width: 90vw;
}
.el-tooltip__popper .popper__arrow {
  // border-color: var(--darker-border-color);
}
.el-tooltip__popper.is-lightfull {
  // background: linear-gradient(45deg, #ff0000, #ff7f00, #ffff00, #00ff00, #0000ff, #4b0082, #8b00ff);
  background-color: #ffffff;
  border-color: #ffffff;
  color: var(--v4-dark-font-color);
  max-width: 90vw;
}

.backButtonContainer {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}

.constantScroll {
  .el-table__body-wrapper {
    transform: rotateX(180deg);
  }
  .el-table--scrollable-x .el-table__body-wrapper {
    transform: rotateX(180deg);
    overflow-x: scroll;
  }
  .el-table__body {
    transform: rotateX(180deg);
  }
  .el-table__empty-block {
    transform: rotateX(180deg);
  }
  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, .25);
    box-shadow: 0 0 1px rgba(255, 255, 255, .25);
  }
}
.el-date-editor .el-range-separator {
  width: auto;
}
</style>


// WEBPACK FOOTER //
// src/App.vue